// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber7 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M11.795 17c.91-2.506 2.002-5.362 3.668-8.596V6.948H9.107v1.554h3.682c.308 0 .574 0 .868-.014v.028c-1.428 2.59-2.716 5.656-3.752 8.484z" />
  );
export default SvgIconNumber7;
